export const checkStatus = (response: any) => {
  if (response && response.status === 200) {
    return response;
  }
  throw response;
};

export const encodeFormData = (data: Object): string => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};
